import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon, Popup } from 'semantic-ui-react'

import './CompactModeToggle.css'

/**
 * Toggle button that switches between standard and compact (grouped by level) view
 * for the professional figures list.
 *
 * Props:
 *   isCompact    {boolean}   Whether compact mode is currently active
 *   onToggle     {Function}  Callback to toggle compact mode. Firma: fn()
 *   disabled     {boolean}   [optional] Disables the toggle. Default: false
 *   fixed        {boolean}   [optional] Positions the toggle fixed next to the tab bar. Default: false
 */
const CompactModeToggle = ({ isCompact, onToggle, disabled = false, fixed = false }) => {
  const wrapperClass = fixed
    ? 'compact-mode-toggle-wrapper-fixed'
    : 'compact-mode-toggle-wrapper'

  const tooltipContent = isCompact
    ? 'Switch back to the standard flat list of professional figures.'
    : 'Group professional figures by company and level in a collapsible view.'

  return (
    <div className={wrapperClass}>
      <Button
        toggle
        active={isCompact}
        onClick={onToggle}
        disabled={disabled}
        size="small"
        className="compact-mode-toggle-btn"
        aria-pressed={isCompact}
        aria-label={isCompact ? 'Switch to standard view' : 'Switch to compact view grouped by level'}
      >
        <Icon name={isCompact ? 'th list' : 'th'} />
        {isCompact ? 'Standard View' : 'Compact Mode'}
      </Button>
      <Popup
        content={tooltipContent}
        trigger={<Icon name="info circle" className="compact-mode-info-icon" />}
        position="bottom center"
        size="small"
      />
    </div>
  )
}

CompactModeToggle.propTypes = {
  isCompact: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fixed: PropTypes.bool,
}

export default CompactModeToggle
